import { generatePath, Link } from "react-router-dom"
import { Button } from "antd"
import { PlusCircleOutlined } from "@ant-design/icons"

import { paths } from "@src/app/paths"

type Props = {
  className?: string
  icon?: JSX.Element
  text: string
  to: (typeof paths)[keyof typeof paths] | string
}
export function CreateButton({
  className,
  icon = <PlusCircleOutlined />,
  text = "Create",
  to,
}: Props) {
  return (
    <Link
      className={className}
      id="GENERATED_ID_CREATEBUTTON_LINK_VOID_1"
      to={generatePath(to, { id: "new" })}
    >
      <Button
        icon={icon}
        id="GENERATED_ID_CREATEBUTTON_BUTTON_VOID_1"
        size="large"
        type="primary"
      >
        {text}
      </Button>
    </Link>
  )
}
